import { SingleExpression, Expression } from '@/models'

export function flattenExpression(expression: Expression | null | undefined): SingleExpression[] {
  if (!expression) return []

  if (expression.type === 'and') {
    return [...flattenExpression(expression.left), ...flattenExpression(expression.right)]
  }

  if (expression.type === 'eq' || expression.type === 'ne') {
    if (
      expression.left.type === 'artifact.attribute' ||
      expression.left.type === 'artifact.property'
    ) {
      if (expression.right.type === 'literal') {
        return [
          {
            type: expression.type,
            left: expression.left,
            right: expression.right,
          },
        ]
      }
    }
  }

  return []
}

export function buildExpression(exprs: SingleExpression[]): Expression | null {
  if (exprs.length === 0) {
    return null
  }

  if (exprs.length > 1) {
    const right = buildExpression(exprs.slice(1))

    if (right) {
      return {
        type: 'and',
        left: exprs[0],
        right,
      }
    }
  } else {
    return {
      type: exprs[0].type,
      left: exprs[0].left,
      right: exprs[0].right,
    }
  }

  return null
}

export function hasToolboxExpression(expr: Expression): boolean {
  if (expr.type === 'toolbox.assist' || expr.type === 'toolbox.assist.binary') return true

  if (expr.type === 'and' || expr.type === 'eq' || expr.type === 'ne')
    return hasToolboxExpression(expr.left) || hasToolboxExpression(expr.right)

  return false
}
